export const getNotificationLink = (notification) => {
    if (notification.type === 'orderTenderDirectMessage') {
        return `/order/${notification?.sourceId}`;
    } else if (notification.type === 'orderDirectMessage') {
        return `/order/${notification?.sourceId}`;
    } else if (notification.type === 'progressUpdateTender') {
        return `/order/${notification?.sourceId}`;
    } else if (notification.type === 'progressUpdate') {
        return `/order/${notification?.sourceId}`;
    } else if (notification.type === 'tenderNewBid') {
        return `/order/${notification?.sourceId}`;
    }
};